
export const apiUrl = process.env.API_URL
export const version = process.env.VERSION
export const cdnDomain = process.env.CDN_DOMAIN
export const leaderBoardPoints = process.env.LEADER_BOARD_POINTS
export const termsLink = process.env.TERMS_LINK
export const policyLink = process.env.POLICY_LINK
export const educationLink = process.env.EDUCATION_URL
export const remediatorLink = process.env.REMEDIATOR_URL
export const lmsUrl = process.env.LMS_URL
export const hfv3Url = process.env.HFV3_URL
export const hfv3apiUrl = process.env.HFV3_API_URL
export const erv2apiUrl = process.env.ERV2_API_URL
export const adUrl = process.env.AD_URL
export const recipientAdUrl = process.env.RECIPIENT_AD_URL 
export const mainDomain = process.env.MAIN_DOMAIN
export const userTokenStorageKey = 'APP_USER_TOKEN'
export const privacy_policy_url = process.env.PRIVACY_POLICY
export const samlUrl = process.env.SAML_URL
export const hfimap = process.env.HF_IMAP



// WEBPACK FOOTER //
// ./src/config.js